// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"ec27ad16","299":"8377b73f","335":"e918f004","394":"1f5647d2","463":"7a55cdc9","691":"b880e39c","722":"f1dfd552","787":"28cb0dcd","825":"79bc3728","964":"7d52bd8f","972":"b58acb31"}[chunkId] + ".chunk.js";
};